import prashkovsky from "@/assets/clients/prashkovsky.webp";
import redPlus from "@/assets/clients/red-plus.webp";

export interface Client {
  name: string;
  src: string;
  /** Optional width hint for visual balance (in px, mapped via CSS max-h) */
  scale?: number;
}

export const clients: Client[] = [
  { name: "פרשקובסקי", src: prashkovsky },
  { name: "RED+ Real Estate Development", src: redPlus },
];
